// src/components/infografia/properties/ShapeProperties.jsx
import React from 'react';

const ShapeProperties = ({ element, onUpdate }) => {
    const props = element.propiedades || {};

    const handleChange = (field, value) => {
        onUpdate({
            propiedades: {
                ...props,
                [field]: value
            }
        });
    };

    return (
        <div className="space-y-4">
            {/* Tipo de forma */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tipo
                </label>
                <select
                    value={props.tipo || 'rectangulo'}
                    onChange={(e) => handleChange('tipo', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    <option value="rectangulo">Rectángulo</option>
                    <option value="cuadrado">Cuadrado</option>
                    <option value="circulo">Círculo</option>
                    <option value="elipse">Elipse/Óvalo</option>
                    <option value="triangulo">Triángulo</option>
                    <option value="triangulo-equilatero">Triángulo Equilátero</option>
                    <option value="rombo">Rombo</option>
                    <option value="paralelogramo">Paralelogramo</option>
                    <option value="trapecio">Trapecio</option>
                    <option value="pentagono">Pentágono</option>
                    <option value="hexagono">Hexágono</option>
                    <option value="heptagono">Heptágono</option>
                    <option value="octagono">Octágono</option>
                    <option value="nonagono">Nonágono</option>
                    <option value="decagono">Decágono</option>
                    <option value="estrella">Estrella</option>
                    <option value="flecha-derecha">Flecha Derecha</option>
                    <option value="flecha-izquierda">Flecha Izquierda</option>
                    <option value="corazon">Corazón</option>
                    <option value="cruz">Cruz</option>
                </select>
            </div>

            {/* Color de relleno */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Color de Relleno
                </label>
                <div className="flex items-center gap-2">
                    <input
                        type="color"
                        value={props.colorRelleno || '#000000'}
                        onChange={(e) => handleChange('colorRelleno', e.target.value)}
                        className="w-12 h-12 border border-gray-300 rounded cursor-pointer"
                    />
                    <input
                        type="text"
                        value={props.colorRelleno || '#000000'}
                        onChange={(e) => handleChange('colorRelleno', e.target.value)}
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>
            </div>

            {/* Color de borde */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Color de Borde
                </label>
                <div className="flex items-center gap-2">
                    <input
                        type="color"
                        value={props.colorBorde || '#000000'}
                        onChange={(e) => handleChange('colorBorde', e.target.value)}
                        className="w-12 h-12 border border-gray-300 rounded cursor-pointer"
                    />
                    <input
                        type="text"
                        value={props.colorBorde || '#000000'}
                        onChange={(e) => handleChange('colorBorde', e.target.value)}
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>
            </div>

            {/* Grosor de borde */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Grosor de Borde: {props.grosorBorde || 0}px
                </label>
                <input
                    type="range"
                    min="0"
                    max="20"
                    value={props.grosorBorde || 0}
                    onChange={(e) => handleChange('grosorBorde', parseInt(e.target.value))}
                    className="w-full"
                />
            </div>

            {/* Opacidad */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Opacidad: {Math.round((props.opacidad || 1) * 100)}%
                </label>
                <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    value={props.opacidad || 1}
                    onChange={(e) => handleChange('opacidad', parseFloat(e.target.value))}
                    className="w-full"
                />
            </div>
        </div>
    );
};

export default ShapeProperties;

